import React from 'react';
import { CFIcon } from '../Icon';
import { CFBaseLogoUtils } from '@connectrn/ds-ui-base';
const { getLogoColor } = CFBaseLogoUtils;
export const CFLogo = ({ color = 'default', size = 'lg' }) => {
    return React.createElement(CFIcon, { color: getLogoColor(color), size: size, icon: 'crn-logo' });
};
